"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var mobileStylesHelper_1 = require("../assets/mobileStylesHelper");

var mobile = function mobile(theme) {
  return {
    border: 'none',
    '&$mobileVisible': {
      borderBottom: "thin solid " + theme.colorBorder.normal
    },
    '&$oversize': {
      marginLeft: -theme.x4,
      marginRight: -theme.x4
    }
  };
};

exports.styles = function (theme) {
  return __assign({
    hr: {
      borderBottom: "thin solid " + theme.colorBorder.normal,
      height: 0,
      position: 'relative',
      margin: 0
    },
    oversize: {
      marginLeft: -theme.x5,
      marginRight: -theme.x5
    },
    mobileVisible: {}
  }, mobileStylesHelper_1.default(mobile(theme)));
};